import { z } from 'zod';

import { type ResumeAction, resumeActionSchema } from '~/shared/data-contract/chat/chat-resume-payload';

/** The legacy interaction callback answers with the same actions an AG-UI resume entry carries. */
export type CallbackAction = ResumeAction;

export const callbackRequestSchema = z.object({
    actions: z.array(resumeActionSchema),
});

export type CallbackRequest = z.infer<typeof callbackRequestSchema>;
